import React, { useState } from 'react'

import './select-goods-group.scss'
import { getBEMCls } from '@/utils/classname'
import { Group } from '@/model/types/goods'
import { $post } from '@/api'
import { useRequest } from 'ahooks'
import { Expaned, Column } from '@/components/layout/layout'
import SelectGoodsGroupItem from './select-goods-group-item'
import { deepClone, get } from '@/utils'
import { Spin } from 'antd'
import { selectGoodStore } from '../model'

const SelectGoodsGroup = () => {
    const getCls = (e?: string, m?: string) => getBEMCls('select-goods-group', e, m)

    const [groupArr, setGroupArr] = useState<Group[]>([])
    const [secondGroupId] = useState<number>(0)

    const { loading } = useRequest(
        () =>
            $post({
                url: '/goods/getgoodsgroup',
            }),
        {
            onSuccess: async (e: Group[]) => {
                const addOpenStatus = e.map((item, index) => ({
                    ...item,
                    open: groupArr.length ? groupArr[index].open : false, // 缓存分组展开状态
                }))
                setGroupArr(addOpenStatus)
                selectGoodStore.setActiveId(e[0].id)
                if (get(e[0], 'secondary_group[0].id')) selectGoodStore.setSecondId(e[0].secondary_group[0].id)
            },
        },
    )

    return (
        <Column className={getCls()}>
            <Spin spinning={loading} className={loading ? getCls('spin') : ''} />
            <Expaned className={getCls('content')}>
                {!!groupArr.length &&
                    groupArr.map((group, index) => (
                        <div key={group.id}>
                            <SelectGoodsGroupItem
                                group={group}
                                groupArr={groupArr}
                                groupIndex={index}
                                onClick={(val, index) => {
                                    if (val[index].secondary_group.length) val[index].open = !val[index].open
                                    setGroupArr(deepClone(val))
                                }}
                                secondGroupId={secondGroupId}
                            />
                        </div>
                    ))}
            </Expaned>
        </Column>
    )
}

export default SelectGoodsGroup
